<div class="w-full h-full flex items-center justify-center content-center">
  <div *ngIf="step === 0 && !loading" class="py-72 w-full flex flex-col gap-12 items-center justify-center content-center appear">
    <fun-overal-message [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="onBtnEvent()"></fun-overal-message>
    <!-- Aviso de cámara (solo web): tarjeta con los pasos para activarla en Android e iPhone -->
    <div *ngIf="showCameraTip"
      class="w-full max-w-[430px] mt-12 p-16 flex flex-col gap-12 rounded-2xl bg-cream-25 border border-eggplant-100/[0.1] font-sans text-left">
      <div class="flex gap-12 items-start">
        <fun-icon class="shrink-0" [name]="'info-circle'" [style]="'w-24 h-24 stroke-eggplant-80 stroke-2'"></fun-icon>
        <p class="text-m text-eggplant-100">{{ 'register.identity_verification.camera_tip' | translate }}</p>
      </div>
      <button type="button" (click)="toggleCameraSteps()" [attr.aria-expanded]="cameraStepsOpen"
        class="w-full flex items-center justify-between gap-12 px-16 py-12 rounded-xl bg-white border border-eggplant-100/[0.1] cursor-pointer text-m font-medium text-eggplant-100">
        <span>{{ 'register.identity_verification.camera_tip_link' | translate }}</span>
        <fun-icon class="shrink-0" [name]="cameraStepsOpen ? 'chevron-up' : 'chevron-down'" [style]="'w-20 h-20 stroke-eggplant-80 stroke-2'"></fun-icon>
      </button>
      <div *ngIf="cameraStepsOpen" class="flex flex-col gap-12">
        <div class="flex gap-4 p-4 rounded-xl bg-eggplant-100/[0.05]" role="tablist">
          <button type="button" role="tab" [attr.aria-selected]="cameraOs === 'android'" (click)="setCameraOs('android')"
            class="flex-1 py-8 rounded-lg cursor-pointer text-m"
            [ngClass]="cameraOs === 'android' ? 'bg-white shadow font-medium text-eggplant-100' : 'text-eggplant-70'">Android</button>
          <button type="button" role="tab" [attr.aria-selected]="cameraOs === 'ios'" (click)="setCameraOs('ios')"
            class="flex-1 py-8 rounded-lg cursor-pointer text-m"
            [ngClass]="cameraOs === 'ios' ? 'bg-white shadow font-medium text-eggplant-100' : 'text-eggplant-70'">iPhone</button>
        </div>
        <ol class="flex flex-col gap-12">
          <li *ngFor="let cameraStep of cameraSteps; let i = index" class="flex gap-12 items-start">
            <span class="shrink-0 w-24 h-24 rounded-full bg-eggplant-100 text-white text-s font-medium flex items-center justify-center">{{ i + 1 }}</span>
            <span class="text-m text-eggplant-100 pt-2">{{ cameraStep }}</span>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <!-- En web móvil, espacio bajo el iframe para que los botones de Mangopay no queden tapados por la barra del navegador -->
  <div *ngIf="step === 1 && !loading" [ngClass]="{ 'pb-[calc(env(safe-area-inset-bottom)+120px)]': mobileWebSpacing }">
    <div class="py-32 w-full flex flex-col gap-72 items-center justify-center content-center appear"
      *ngIf="!iframeLoaded">
      <div class="pt-[32px]"><fun-icon [name]="'wifi'"
          [style]="'w-96 h-96 stroke-[2px] stroke-eggplant-70 animate-gradientX'"></fun-icon></div>
      <p class="text-center font-sans text-h400 md:text-h600 text-eggplant-70 animate-gradientX">{{ 'SCA.VALIDATING' |
        translate }}</p>
    </div>
    <!-- allow tiene que ser estático (NG0910): con cámara en nativo y web móvil, sin ella en web de escritorio (QR) -->
    <iframe *ngIf="urlSafeCategorize && cameraInIframe" class="w-full h-full"
      [ngClass]="{ 'min-h-[720px] min-w-[350px] md:min-w-[430px]': iframeLoaded }" [src]="urlSafeCategorize" frameborder="0"
      (load)="charged($event)" #iframe allow="camera; microphone; fullscreen; autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
    <iframe *ngIf="urlSafeCategorize && !cameraInIframe" class="w-full h-full"
      [ngClass]="{ 'min-h-[720px] min-w-[350px] md:min-w-[430px]': iframeLoaded }" [src]="urlSafeCategorize" frameborder="0"
      (load)="charged($event)" #iframe allow="fullscreen; autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
  </div>

  <div *ngIf="step === 2 && !loading" [ngClass]="{ 'pb-[calc(env(safe-area-inset-bottom)+120px)]': mobileWebSpacing }">
    <div class="py-32 w-full flex flex-col gap-72 items-center justify-center content-center appear"
      *ngIf="!iframeLoaded">
      <div class="pt-[32px]"><fun-icon [name]="'wifi'"
          [style]="'w-96 h-96 stroke-[2px] stroke-eggplant-70 animate-gradientX'"></fun-icon></div>
      <p class="text-center font-sans text-h400 md:text-h600 text-eggplant-70 animate-gradientX">{{ 'SCA.VALIDATING' |
        translate }}</p>
    </div>
    <!-- allow tiene que ser estático (NG0910): con cámara en nativo y web móvil, sin ella en web de escritorio (QR) -->
    <iframe *ngIf="urlSafeIdentityVerification && cameraInIframe" class="w-full h-full"
      [ngClass]="{ 'min-h-[720px] min-w-[350px] md:min-w-[430px]': iframeLoaded }" [src]="urlSafeIdentityVerification" frameborder="0"
      (load)="charged($event)" #iframe allow="camera; microphone; fullscreen; autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
    <iframe *ngIf="urlSafeIdentityVerification && !cameraInIframe" class="w-full h-full"
      [ngClass]="{ 'min-h-[720px] min-w-[350px] md:min-w-[430px]': iframeLoaded }" [src]="urlSafeIdentityVerification" frameborder="0"
      (load)="charged($event)" #iframe allow="fullscreen; autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
  </div>

  <div *ngIf="step === 3 && !loading"
    class="py-72 w-full flex flex-col gap-12 items-center justify-center content-center appear">
    <fun-overal-message [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="onBtnEvent()"></fun-overal-message>
  </div>

  <div *ngIf="step === 4 && !loading"
    class="py-72 w-full flex flex-col gap-12 items-center justify-center content-center appear">
    <fun-overal-message [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="finish()"></fun-overal-message>
  </div>

  <fun-spinner *ngIf="loading"></fun-spinner>
</div>
